import { Typography } from "@packages/ds";
import styled from "styled-components";

import SanitizedHTML from "Components/SanitizedHTML";

export const Wrapper = styled.section`
  padding: 32px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;

  &:focus {
    outline: none;
  }

  h2 {
    margin-bottom: 16px;
    line-height: 33px;

    span {
      font-size: 14px;
      color: var(--section-granite-color, var(--granite));
      font-weight: normal;
    }
  }

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledSanitizedHTML = styled(SanitizedHTML)`
  > p,
  > ul {
    color: var(--section-ebony-light-color, var(--ebony-light));
    font-size: 14px;
  }
  > p {
    line-height: 24px;
    margin: 0 0 5px;
  }
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

export const NoCopyCode = styled.pre`
  padding: 12px 24px;
  line-height: 19px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  font-style: italic;
  margin-bottom: 24px;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const CodeExample = styled.div`
  position: relative;
  margin: 29px 0 20px;
`;
